export function getTempId(): number {
  return Math.round(Math.random() * -1000000);
}
